import axios from 'axios';


import store from '@/store'

export default {
    watch: {
        // displayItems: {
        //   handler() {
        //     this.rentalPriceTotal = 0;
        //     this.bailTotal = 0;
        //     this.grandTotal = 0;

        //     for (var i = 0; i < this.displayItems.length; i++) {
        //       this.rentalPriceTotal =
        //         this.rentalPriceTotal +
        //         this.displayItems[i].rentalPrice *
        //         this.displayItems[i].reservedQuantity;

        //       this.bailTotal =
        //         this.bailTotal +
        //         this.displayItems[i].rentalPrice *
        //         this.displayItems[i].reservedQuantity;
        //     }
        //     this.grandTotal =
        //       this.grandTotal + this.rentalPriceTotal + this.bailTotal;
        //   },
        //   deep: true
        // }
    },
    methods: {

         limitText(text,len){
        if(text === null || text === undefined){
            return "ไม่ระบุ";
        }
        return text.substring(0,len);
        },

        convertToArray(list, prop){
            var newlist = [];

  

            for (var i = 0; i < list.length; i++) {
              newlist.push(list[i][prop]);
            }
          
            return newlist;
        },
        // automapper(list, keys){
        //     var newlist = [];
        //     for (let i = 0; i < list.length; i++) {
        //       var item = {};
        //       for (let j = 0; j < keys.length; j++) {
        //         if (list[0].hasOwnProperty(keys[j])) {
        //           item[keys[j]] = list[i][keys[j]];
        //         }
          
        //       }
        //       const it = Object.assign({}, item);
        //       newlist.push(it);
        //     }
          
        //     return newlist;
          
        // },
        removeArray(arr, attr, value) {
            var removeIndex = [];
            for (var i = 0; i < arr.length; i++) {
                if (arr[i][attr] === value) {
                    removeIndex.push(i);
                }
            }

            for (var k = removeIndex.length - 1; k >= 0; k--)
                arr.splice(removeIndex[k], 1);
        },
        redirectToExternal(url) {
            location.replace(url);
        },
        moveTo(groupid) {
            this.$router.push("/product-detail/" + groupid);
        },
        moveToCart() {
            this.$router.push("/cart");
        },
        goHome() {
            this.$router.push("/");
        },

        detectmob() {
            if (window.innerWidth <= 800) {
                return true;
            } else {
                return false;
            }
        },

        getProductPath(mainImage) {
            if (mainImage === undefined || mainImage === null || mainImage === "") {
                return store.state.apiImageUrl + "defaultimage.png";
            } else {
                return store.state.apiImageUrl + "item/" + mainImage;
            }
        },
        getFullPath(mainImage) {
            if (mainImage === undefined || mainImage === null || mainImage === "") {
                return store.state.imageUrl + "defaultimage.png";
            } else {
                return store.state.imageUrl + mainImage;
            }
        },

        getApiPath(mainImage) {
            if (mainImage === undefined || mainImage === null || mainImage === "") {
                return store.state.imageUrl + "lo3_1.png";
            } else {
                return store.state.apiImageUrl + mainImage;
            }
        },
        getPath(url) {
            if (url === undefined || url === null || url === "") {
                return store.state.mainUrl + "defaultimage.png";
            } else {
                return store.state.mainUrl + url;
            }
        },

        async checkQueueShare(list) {
            var res = null;
            try {
                res = await axios.post(
                    store.state.apiURL + "/api/orderdetail/checkq",
                    list
                );
            } catch (error) {
                this.noticeError(error);
                return null;

            }

            return await res.data;
        },

        generateRandom(length) {
            var result = '';
            var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for (var i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        },
        numRange(num) {
            var arr = [] // create an empty array with length #num
            for (var i = 0; i < num; i++) {
                arr.push(i);
            }
            return arr;
        },
        filteringMore(
            list /* Array of object list */ ,
            filtering /* Array single list */ ,
            filedName
        ) {
            var templist = [];
            if (filtering.length >= 1) {
                for (var i = 0; i < list.length; i++) {
                    for (var j = 0; j < filtering.length; j++) {
                        if (list[i][filedName] === filtering[j]) {
                            templist.push(list[i]);
                        }
                    }
                }
            }
            return templist;
        },

        searchByDate(list, startDate, endDate, filedName) {
            var templist = [];
            for (var i = 0; i < list.length; i++) {
                var listdate = this.formatDate(list[i][filedName]);
                var ckin = this.formatDate(startDate);
                var ckout = this.formatDate(endDate);


                if (listdate >= ckin && listdate <= ckout) {
                    templist.push(list[i]);
                }
            }

            return templist;
        },


        descendingSortShare(inputList, sortingField) {
            var list = [];
            for (var i = 0; i < inputList.length; i++) {
                list.push(inputList[i]);
            }
            list.sort((a, b) => b[sortingField] - a[sortingField]);
            return list;
        },
        descendingDateSortShare(inputList, sortingField) {
            var list = [];
            for (var i = 0; i < inputList.length; i++) {
                list.push(inputList[i]);
            }
            list.sort((a, b) => new Date(b[sortingField]) - new Date(a[sortingField]));
            return list;
        },

        ascendingSortShare(inputList, sortingField) {
            var list = [];
            for (var i = 0; i < inputList.length; i++) {
                list.push(inputList[i]);
            }
            list.sort((a, b) => a[sortingField] - b[sortingField]);
            return list;
        },

        ascendingDateSortShare(inputList, sortingField) {
            var list = [];
            for (var i = 0; i < inputList.length; i++) {
                list.push(inputList[i]);
            }
            list.sort((a, b) => new Date(a[sortingField]) - new Date(b[sortingField]));
            return list;
        },



        date_diff_indays(date1, date2) {
            var dt1 = new Date(date1);
            var dt2 = new Date(date2);
            return Math.floor(
                (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
                    Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
                (1000 * 60 * 60 * 24)
            );
        },

        getdate(dad, amount) {


            var newdate = new Date(dad);

            newdate.setDate(newdate.getDate() + amount);

            var dd = newdate.getDate();
            var mm = newdate.getMonth() + 1;
            var y = newdate.getFullYear();

            var someFormattedDate = y + '-' + mm + '-' + dd;
            return someFormattedDate;
        },

        addDay(date, days) {
            const copy = new Date(Number(date));
            copy.setDate(date.getDate() + days);
            return copy;
        },
        realRentalPrice(rentalPrice, rentalDiscount, promotionDiscount) {
            var rp = isNaN(Number(rentalPrice)) ? 0 : Number(rentalPrice);

            var rd = isNaN(Number(rentalDiscount)) ? 0 : Number(rentalDiscount);

            var pd = isNaN(Number(promotionDiscount)) ? 0 : Number(promotionDiscount);

            return this.formatPrice(rp - rd - pd);
        },
        realBail(bailTotal, bailDiscount) {
            var bt = isNaN(Number(bailTotal)) ? 0 : Number(bailTotal);
            var bd = isNaN(Number(bailDiscount)) ? 0 : Number(bailDiscount);
            return this.formatPrice(bt - bd);
        },
        realReturn(bailTotal, bailDiscount, deduction) {
            var bt = isNaN(Number(bailTotal)) ? 0 : Number(bailTotal);
            var bd = isNaN(Number(bailDiscount)) ? 0 : Number(bailDiscount);
            var dd = isNaN(Number(deduction)) ? 0 : Number(deduction);
            return this.formatPrice(bt - bd - dd);
        },
        getPermission() {
            return store.state.auth.permission;
        },
        checkPermissionShare(roles) {
            var pm = roles.filter(
                x =>
                x.roleName === "owner" ||
                x.roleName === "admin" ||
                x.roleName === "accountingadmin" ||
                x.roleName === "useradmin"
            );
            if (pm.length >= 1) {
                return "admin";
            } else {
                return "staff";
            }
        },

        async getList(url) {
            // this.$vs.loading({
            //   type: "radius"
            // });
            var response = null;
            try {
                response = await axios.get(
                    store.state.apiURL + url
                );
            } catch (error) {
                setTimeout(() => {
                    // this.$vs.loading.close();
                }, 1000);
                this.noticeError(error);
                return null;

            }

            setTimeout(() => {
                // this.$vs.loading.close();
            }, 1000);

            return await response.data;
        },
        async getOne(url) {

            var response = null;
            try {
                response = await axios.get(
                    url
                );
            } catch (error) {

                // this.noticeError(error);
                return null;

            }

            return await response.data;
        },
        async updateShare(url, item, id) {
            // this.$vs.loading({
            //   type: "radius"
            // });
            var response;
            try {
                response = await this.$http.put(
                    this.$store.state.apiURL + url + "/" + id,
                    item
                );

            } catch (error) {
                setTimeout(() => {
                    // this.$vs.loading.close();
                }, 300);
                this.noticeError(error);
                return null;
            }
            setTimeout(() => {
                this.noticeSuccess("บันทึกสำเร็จ");
                this.$vs.loading.close();
            }, 300);

            return await response.data;
        },
        async createShare(url, item) {
            this.$vs.loading({
                type: "radius"
            });
            var response;
            try {
                response = await this.$http.post(
                    this.$store.state.apiURL + url,
                    item
                );

            } catch (error) {
                setTimeout(() => {
                    this.$vs.loading.close();
                }, 300);
                this.noticeError(error);
                return null;
            }
            setTimeout(() => {
                this.noticeSuccess("บันทึกสำเร็จ");
                this.$vs.loading.close();
            }, 300);

            return await response.data;
        },

        async loadAllOrderShare() {
            var response = null;
            try {
                response = await axios.get(
                    store.state.apiURL + "/api/orderheader"
                );
            } catch (error) {
                this.noticeError(error);
                return null;

            }

            return await response.data;
        },
        async loadAllDetailShare() {
            var response;
            try {
                response = await axios.get(
                    store.state.apiURL + "/api/orderdetail"
                );
            } catch (error) {
                this.noticeError(error);
            }

            return await response.data;
        },
        async loadDetailShare(orderId) {
            var response;
            try {
                response = await axios.get(
                    store.state.apiURL + "/api/orderdetail/" + orderId
                );
            } catch (error) {
                this.noticeError(error);
            }

            return await response.data;
        },

        async loadBranchShare(id) {
            var response = null;
            try {
                response = await axios.get(
                    store.state.apiURL + "/api/branch/" + id
                );
            } catch (error) {
                this.noticeError(error);
                return null;
            }

            return await response.data;
        },

        async loadBranchOrderShare(branchId) {
            var response;
            try {
                response = await axios.get(
                    store.state.apiURL + "/api/orderheader/branch/" + branchId
                );
            } catch (error) {
                this.noticeError(error);
            }

            return await response.data;
        },
        async loadBranchOrderPickupdateSortShare(branchId) {
            var response;
            try {
                response = await axios.get(
                    store.state.apiURL + "/api/orderheader/branch/pickupdate-sort/" + branchId
                );
            } catch (error) {
                this.noticeError(error);
            }

            return await response.data;
        },
        async getBranchByCode(code) {

            var br = await this.loadAllBranchShare();
            var aBranch = null;

            if (br === null || br === undefined || br.length === 0) {
                aBranch = await br.find(x => x.code === "0");
            } else {
                aBranch = await br.find(x => x.code === code);

            }

            return aBranch;

        },

        async getBranchShare(id) {

            var response;
            try {
                response = await axios.get(
                    store.state.apiURL + "/api/branch/" + id
                );
            } catch (error) {
                this.noticeError(error);
                return null;
            }

            return await response.data;


        },

        async loadAllBranchShare() {
            var response;
            try {
                response = await axios.get(
                    store.state.apiURL + "/api/branch"
                );
            } catch (error) {
                this.noticeError(error);
                return null;
            }

            return await response.data;
        },


        // noticeSuccess(text) {
        //     // this.$vs.notify({
        //     //     title: "ดำเนินการสำเร็จ",
        //     //     position: "top-center",
        //     //     text: text,
        //     //     iconPack: "feather",
        //     //     icon: "icon-alert-circle",
        //     //     color: "success"
        //     // });
        // },
        // noticeError(text) {
        //     // this.$vs.notify({
        //     //     title: "เกิดข้อผิดพลาด",
        //     //     position: "top-center",
        //     //     text: text,
        //     //     iconPack: "feather",
        //     //     icon: "icon-alert-circle",
        //     //     color: "danger"
        //     // });
        // },
        // noticeWarning(title, text) {
        //     // this.$vs.notify({
        //     //     title: title,
        //     //     position: "top-center",
        //     //     text: text,
        //     //     iconPack: "feather",
        //     //     icon: "icon-alert-circle",
        //     //     color: "warning"
        //     // });
        // },
        // noticeInfo(text) {
        //     // this.$vs.notify({
        //     //     title: "เกิดข้อผิดพลาด",
        //     //     position: "top-center",
        //     //     text: text,
        //     //     iconPack: "feather",
        //     //     icon: "icon-alert-circle",
        //     //     color: "info"
        //     // });
        // },

        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        },
        formatDateLocal(date) {
            return this.formatDate(date) + "T00:00:00.000Z";
        },
        formatPrice(value) {
            // var number = +value.replace(/[^\d.]/g, "");
            value = this.convertToNum(value);
            var amount = isNaN(value) ? 0 : value;

            return amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        },
        convertToNum(value) {
            if (typeof value === 'string') {

                value = Number(value.replace(",", ""));
            }
            if (isNaN(value)) {
                value = 0;
            }
            return value;
        },
        numberFormat(value) {
            if (isNaN(Number(value))) return 0;
            return Number(value);
        },
        // Returns if value is a date object
        isDate(value) {
            return value instanceof Date;
        }
    }
}